// ==============================|| API ENDPOINTS ||============================== //

// API Base URL
export const API_BASE_URL = 'https://multitenant.zoiteckh.com/api/core';
export const API_BASE_URL_WIthoutCore = 'https://multitenant.zoiteckh.com/api';

// API Endpoints
const endpoints = {
  // Auth endpoints
  auth: {
    login: `${API_BASE_URL}/token/`,
    refresh: `${API_BASE_URL}/token/refresh/`,
    changePassword: `${API_BASE_URL}/auth/change-password/`
  },

  // User endpoints
  user: {
    profile: `${API_BASE_URL}/user/profile`,
    update: `${API_BASE_URL}/user/update`
  },
  registration: {
    industries: `${API_BASE_URL}/industries/`,
    createIndustry: `${API_BASE_URL}/industries/`,
    createTentants: `${API_BASE_URL}/tenant/create/`,
    publicSignup: `${API_BASE_URL}/signup/`,
    aiGenerateContent: `${API_BASE_URL}/ai/generate-content/`,
    demoRequest: `${API_BASE_URL}/demo-request/`,
    demoScheduled: `${API_BASE_URL}/demo-request/scheduled/`
  },
  productDeck: {
    list: `${API_BASE_URL}/product-deck/`,
    detail: (id) => `${API_BASE_URL}/product-deck/${id}/`
  },
  prospects: {
    template: `${API_BASE_URL}/prospects/template/`,
    preview: `${API_BASE_URL}/prospects/preview/`,
    categories: `${API_BASE_URL}/prospects/categories/`,
    import: `${API_BASE_URL}/prospects/import/`,
    list: `${API_BASE_URL}/prospects/`,
    convert: (id) => `${API_BASE_URL}/prospects/${id}/convert/`,
    convertBulk: `${API_BASE_URL}/prospects/convert-bulk/`,
  },

  // Public: resolve a custom domain to company slug
  domainLookup: (host) => `${API_BASE_URL}/domain-lookup/?host=${encodeURIComponent(host)}`,

  // Super-admin platform totals (active companies, leads, bookings)
  platformStats: `${API_BASE_URL}/platform-stats/`,

  // Super-admin staff user management
  manageUsers: `${API_BASE_URL}/manage-users/`,
  manageUser: (id) => `${API_BASE_URL}/manage-users/${id}/`,
  resetUserPassword: (id) => `${API_BASE_URL}/manage-users/${id}/reset-password/`,
  adminChangePassword: `${API_BASE_URL}/admin-change-password/`,

  // Company/Tenant endpoints
  company: {
    list: `${API_BASE_URL}/tenants/`,
    detail: (id) => `${API_BASE_URL}/tenants/${id}/`,
    companyList: (id) => `${API_BASE_URL}/companies/`,
    adminCreate: `${API_BASE_URL}/admin/create-company/`,
    updateCompany: (id) => `${API_BASE_URL}/companies/${id}/`,
    deleteCompany: (id) => `${API_BASE_URL}/companies/${id}/`,
    doctorList: () => `${API_BASE_URL_WIthoutCore}/hospital/doctors/`,
    updateDoctor: (id) => `${API_BASE_URL_WIthoutCore}/hospital/doctors/${id}/`,
    doctorAvailability: (doctorId) => `${API_BASE_URL_WIthoutCore}/hospital/doctor-availability/${doctorId}/`,
    doctorAvailabilityRow: (doctorId, availabilityId) => `${API_BASE_URL_WIthoutCore}/hospital/doctor-availability/${doctorId}/${availabilityId}/`,
    doctorAvailabilityImpact: (doctorId, availabilityId) => `${API_BASE_URL_WIthoutCore}/hospital/doctor-availability/${doctorId}/${availabilityId}/impact/`,
    doctorSlots: (doctorId) => `${API_BASE_URL_WIthoutCore}/hospital/doctor-slots/${doctorId}/`,
    getCompany: (slug) => `${API_BASE_URL_WIthoutCore}/hospital/doctors-list/s/${slug}/`,
    getCompanyById: (id) => `${API_BASE_URL_WIthoutCore}/hospital/doctors-list/${id}/`,
    getCompanyDoctor: (id, specializationId) => `${API_BASE_URL_WIthoutCore}/hospital/doctors-list/${id}/?specialization_id=${specializationId}`,
    specializations: (id) => `${API_BASE_URL_WIthoutCore}/hospital/specialization/${id}/`,
    specializationsEndUser: (id) => `${API_BASE_URL_WIthoutCore}/hospital/specialization-end-user/${id}/`,
    createSpecialization: `${API_BASE_URL_WIthoutCore}/hospital/specialization/`,
    tokenByUser: `${API_BASE_URL}/token/by-user/`,
    toggleStatus: (id) => `${API_BASE_URL}/tenant/${id}/status/`,
    revertToken: `${API_BASE_URL}/token/revert/`,
    websiteSections: (companyId) => `${API_BASE_URL}/companies/${companyId}/website-sections/`,
    websiteSectionsBulk: (companyId) => `${API_BASE_URL}/companies/${companyId}/website-sections/bulk/`,
    websiteSection: (companyId, sectionType) => `${API_BASE_URL}/companies/${companyId}/website-sections/${sectionType}/`,
    uploadSectionImage: (companyId) => `${API_BASE_URL}/companies/${companyId}/website-sections/upload-image/`,
    locations: (companyId) => `${API_BASE_URL}/companies/${companyId}/locations/`,
    location: (companyId, locationId) => `${API_BASE_URL}/companies/${companyId}/locations/${locationId}/`
  },

  // Appointment endpoints
  appointment: {
    bookAppointment: `${API_BASE_URL_WIthoutCore}/hospital/book-appointment/`,
    patientLookup: `${API_BASE_URL_WIthoutCore}/hospital/patient-lookup/`,
    listAppointments: `${API_BASE_URL_WIthoutCore}/hospital/appointments/`,
    updateAppointment: (id) => `${API_BASE_URL_WIthoutCore}/hospital/appointments/${id}/`
  },

  // End Users endpoints
  endUsers: {
    list: (companyId) => `${API_BASE_URL_WIthoutCore}/hospital/end-users-list/${companyId}/`,
    doctorList: (companyId) => `${API_BASE_URL_WIthoutCore}/hospital/doctors-list/${companyId}/`,
    getUser: (userId) => `${API_BASE_URL_WIthoutCore}/hospital/end-users/${userId}/`,
    bulkDelete: `${API_BASE_URL_WIthoutCore}/hospital/end-users/bulk-delete/`,
    merge: `${API_BASE_URL_WIthoutCore}/hospital/end-users/merge/`
  },

  // Feedback endpoints
  feedback: {
    getUser: (token) => `${API_BASE_URL_WIthoutCore}/hospital/feedback/user/?token=${token}`,
    submit: `${API_BASE_URL_WIthoutCore}/hospital/feedback/submit/`
  },

  // Testimonials endpoints
  testimonials: {
    list: (tenantId) => `${API_BASE_URL_WIthoutCore}/hospital/testimonials/?company_id=${tenantId}`
  },

  // Import endpoints
  importBookings: {
    template: `${API_BASE_URL_WIthoutCore}/hospital/import/template/`,
    preview: `${API_BASE_URL_WIthoutCore}/hospital/import/preview/`,
    validate: `${API_BASE_URL_WIthoutCore}/hospital/import/validate/`,
    execute: `${API_BASE_URL_WIthoutCore}/hospital/import/execute/`
  }
};

export default endpoints;
